/* @flow */

const traduzirDiasDaSemana = (dia: string) => {
    const traducao = {
        Sunday: 'Domingo',
        Monday: 'Segunda',
        Tuesday: 'Terça',
        Wednesday: 'Quarta',
        Thursday: 'Quinta',
        Friday: 'Sexta',
        Saturday: 'Sábado',
    };

    return traducao[dia];
};

export default traduzirDiasDaSemana;
